import { useState, memo } from 'react';
import { useResize } from '@src/hooks/Resize';
import { join } from '@src/utils/helpers'; 

//style imports:
import '@src/scss/components/Block.scss';
const CoreBlock=memo( ({children, className})=>{

    /**
     * make sure children height is not changing w.r.t width of parent.
     */
    const [width,setWidth] = useState('auto');
    const {observe} = useResize();

    const callback=(el)=>{
        let targetHeight=el.clientHeight;
        if(width !== targetHeight) setWidth( el.clientHeight ); //square block according to height.
    }

    return (
        <div className={join('core-block',className)} style={ { width:`${width}px` } } {...observe( callback )}>
            <div className="children">
                {children}
            </div>
                
        </div>
    )
}
);

export {CoreBlock};